import ChannelSwitch from './ChannelSwitch'

export default ChannelSwitch
